<template>
  <div class="row">
    <div class="col-6">
      <label for="inputSelectGrupo">Grupo</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text" id="selectGrupo">
            <i class="fas fa-users fa-fw"></i>
          </span>
        </div>
        <select
          class="form-control"
          id="inputSelectGrupo"
          aria-label="Grupo"
          aria-describedby="selectGrupo"
          required
          v-on:change="changeGroup()"
          name="group"
          ref="group"
        >
          <option disabled value>Selecione</option>
          <option value="*" selected>Todos</option>
          <option :key="key" v-for="(value, key) in groups" :value="value.id">{{ value.group }}</option>
        </select>
      </div>
    </div>
    <div class="col-6">
      <label for="inputSelectRamal">Ramal</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text" id="selectRamal">
            <i class="fas fa-phone-square-alt fa-fw"></i>
          </span>
        </div>
        <select
          class="form-control"
          id="inputSelectRamal"
          aria-label="Ramal"
          aria-describedby="selectRamal"
          name="extension"
        >
          <option disabled value>Selecione</option>
          <option value="*" selected>Todos</option>
        </select>
        <div class="input-group-prepend">
          <button type="submit" id="btnSubmit" class="btn btn-primary">
            <i class="fa fa-search fa-fw"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      groups: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData: function() {
      var self = this;
      axios
        .get("/records/list")
        .then(function(response) {
          self.groups = response.data;
        })
        .catch(function(error) {
          console.error(error);
        })
        .finally(function() {
          $('#inputSelectGrupo')[0].dispatchEvent(new Event('change'))
        });
    },

    changeGroup: function(event) {
      $("#inputSelectRamal option")
        .not(":first, :nth-child(2)")
        .remove();

      if(this.$refs.group.value == '*'){
        $.each(this.groups, function(index, item) {
            $('#btnSubmit, #inputSelectRamal').attr('disabled', false);
            $.each(item.extensions, function(idx, itm) {
              var html = `<option value="${itm}">${itm}</option>`;
              $("#inputSelectRamal").append(html);
            });
        });
      }else{
        $.each(this.groups, function(index, item) {
          if (item.id == $('#inputSelectGrupo').val()) {
            if(item.extensions.length == 0 ){
              $('#btnSubmit, #inputSelectRamal').attr('disabled', true);
            }else{
              $('#btnSubmit, #inputSelectRamal').attr('disabled', false);
              $.each(item.extensions, function(idx, itm) {
                var html = `<option value="${itm}">${itm}</option>`;
                $("#inputSelectRamal").append(html);
              });
            }
          }
        });
      }
    }
  }
};
</script>